import React, { useEffect } from 'react';
import LLMProvidersTab from '../components/LLMProvidersTab';
import { markGenAIOpsStepComplete } from '../../../hooks/useOnboardingStatus';

const LLMProvidersPage: React.FC = () => {
  // Mark onboarding step as complete when visiting this page
  useEffect(() => {
    markGenAIOpsStepComplete('llm_provider');
  }, []);

  return (
    <div className="mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white transition-colors">
          LLM Providers
        </h1>
        <p className="mt-2 text-gray-600 dark:text-gray-400 transition-colors">
          Configure and manage your LLM provider connections and API keys
        </p>
      </div>

      {/* Content */}
      <LLMProvidersTab />
    </div>
  );
};

export default LLMProvidersPage;
